import styles from "./IPCameraVideoStreaming.module.css";
import plusIcon from "../../../../assets/images/plusIcon.png";
import { useState } from "react";
import { FaBan } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  openConfirmationPopup,
  openFailDialog,
} from "../../../../Redux/Actions/PopupActions";
import IPCameraConnectionRequestPopup from "../../Popups/IPCameraConnectionRequestPopup";
import ToolTipPopUP from "../../Popups/TooltipPopup";
import Broadcast from "../Device Video Streaming/pages";
import { setAvsChannelList } from "../../../../Redux/Actions/VideoStreamingActions";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import LoadingButton from "../../../../Common/LoadingButton";
import userService from "../../../../services/user.service";

const IPCameraCard = ({
  videoRef,
  setIsStarted,
  camera,
  setPage,
  page,
  socket,
}) => {
  const adminRole = getFromLocalStorage("loginRole");
  const userId = getFromLocalStorage("currentUserId");
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const assignedRight = JSON.parse(getFromLocalStorage("assignedRights") || []);
  const assignedRights = assignedRight.map((item) => item.displayName);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [loadingButton, setLoadingButton] = useState(null);
  const handleIPCameraConnectionPopUP = (camera) => {
    setOpen(true);
  };
  const schoolId = getFromLocalStorage("schoolId");
  const { videoStreamAvsChannelList, openStreamCamera } = useSelector(
    (state) => state?.videoStreamData
  );
  const videoScheduleInformation = useSelector(
    (state) => state?.videoScheduleInformation
  );
  const currentSchool = useSelector(
    (state) => state.loggedInUser?.school?.schoolName
  );
  const handleIPCameraDisconnectionRequest = () => {
    setAnchorEl(null);
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Disconnect Camera?",
        btnColor: "red",
        btnText: "Yes",
        cameraDetails: {
          ...camera,
          previewStatus: false,
          angle: "",
        },
        type: "IP Camera Disconnection",
      },
    });
  };

  const streamVideo = () => {
    setIsStarted(true);
  };

  const deleteAllChannelHandler = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message: "Are You Sure, You Want To Delete All Channels?",
        btnColor: "red",
        btnText: "Yes",
        type: "Delete all IVS channel",
        item: { channels: videoStreamAvsChannelList, schoolId },
        socket,
        getAllLiveChannel: () => getAllLiveIvsChannel(),
        setLoadingButton: setLoadingButton,
      },
    });
  };

  const getAllLiveIvsChannel = () => {
    setAvsChannelList(dispatch, schoolId);
    userService
      .sendLiveStreamingNotification({
        id: userId,
        schoolId,
        associationType: "Stopped Stream",
      })
      .then(() => {})
      .catch((error) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  const open2 = Boolean(anchorEl);
  const id = open2 ? "simple-popover" : undefined;
  return (
    <>
      <div className={styles.gridItem}>
        <main className={styles.IpCameraBox}>
          {!openStreamCamera && (
            <div
              className={styles.IPCameraContent}
              onClick={() => handleIPCameraConnectionPopUP()}
            >
              <img src={plusIcon} />
              <p className="fs-16 medium colorb4">Click To Connect Camera</p>
            </div>
          )}
          {openStreamCamera && (
            <div>
              <div className="w-100 h-100 position-relative overflow-hidden">
                <Broadcast
                  streamVideo={streamVideo}
                  setPage={setPage}
                  page={page}
                  socket={socket}
                />
              </div>
            </div>
          )}
        </main>
      </div>
      {videoStreamAvsChannelList.length > 0 && (
        <div className="p-20 pl-0 pb-0">
          {videoStreamAvsChannelList
            .filter((ele) => ele.isPrimaryChannel) // Filter once
            .map(
              ({
                opponentSchool,
                seasonType,
                eventName,
                eventType,
                weekName,
                playlistName,
              }) => {
                // Create array of event info, filtering out null/undefined values
                const eventInfo = [
                  seasonType,
                  eventName,
                  eventType,
                  weekName,
                  playlistName,
                ].filter(Boolean);
                return (
                  <div key={opponentSchool}>
                    {" "}
                    {/* Competition Section */}
                    <span className="semi-bold fs-20 p-20 pl-0">
                      Competition:
                    </span>
                    <span className="fs-20 mg-right-5 txtblue bold">
                      {currentSchool}
                    </span>
                    <span className="semi-bold fs-20">VS</span>
                    <span className="fs-20 mg-left txtblue bold">
                      {opponentSchool}
                    </span>
                    <br />
                    {/* Event Section */}
                    <span className="semi-bold fs-20 p-20 pl-0">Event:</span>
                    {eventInfo.map((item, index) => (
                      <span key={index} className="fs-20">
                        <span className="txtblue bold">{item}</span>
                        {index < eventInfo.length - 1 && " > "}
                      </span>
                    ))}
                  </div>
                );
              }
            )}
        </div>
      )}
      <ToolTipPopUP
        id={id}
        open={open2}
        anchor={anchorEl}
        handleClose={handleClose}
        settingList={[
          {
            id: 1,
            name: "Disconnect Camera",
            icon: <FaBan className="manage-section-iconss red" />,
            handleSubmit: () => {
              handleIPCameraDisconnectionRequest();
            },
          },
        ]}
      />
      <IPCameraConnectionRequestPopup
        open={open}
        setOpen={setOpen}
        socket={socket}
      />
      {(adminRole === "SCHOOL ADMIN" ||
        assignedRights.includes("Record Video")) &&
        videoStreamAvsChannelList.length != 0 && (
          <div
            className={`mg-top-20 ${
              videoStreamAvsChannelList.length == 0 && styles.disabled
            }`}
            onClick={deleteAllChannelHandler}
          >
            <LoadingButton
              text={"Stop All Channel"}
              loading={loadingButton === schoolId}
              disabled={videoStreamAvsChannelList.length == 0}
              isZIndex={true}
            />
          </div>
        )}
    </>
  );
};

export default IPCameraCard;
